import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Switch } from 'antd-v5';
import { SettingsContent } from '../../../components/SettingsContent';

export const ProfileNotifications = ({ form }) => {
  return (
    <SettingsContent
      icon={<FontAwesomeIcon icon={['far', 'bell']} />}
      title="Notifications"
      description="SMS notification of new client messages."
      contentClassName="w-100-P"
      action={
        <Form.Item name="message_notifications" valuePropName="checked" style={{ marginBottom: 0 }}>
          <Switch />
        </Form.Item>
      }
    />
  );
};
